// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateProductSize_cancelButton__JTjGz"};